var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var ErrorBoundary_1 = require("../js/common/new-components/ErrorBoundary");
var master_widget_1 = require("./widget/master-widget");
var CommonUtils_1 = require("./common/utils/CommonUtils");
CommonUtils_1.default.loadCustomUtils();
var node = document.getElementById(window['widgetLoadDivId'] || 'content');
var homepageProps = window['HOMEPAGELOAD_PROPS'] || {};
var props = {
    updateURL: true,
    isMobileDevice: false,
    'car-new': homepageProps.carProps,
    'bike-qf': homepageProps.commonProps,
    'health-im': homepageProps.healthProps,
    'health-st': homepageProps.healthProps,
    'travel-st': homepageProps.commonProps,
    'travel-mt': homepageProps.commonProps,
    'life-qf': homepageProps.lifeProps,
    'commercial-car': homepageProps.commonProps,
};
react_dom_1.render(React.createElement(ErrorBoundary_1.default, null,
    React.createElement(master_widget_1.default, __assign({}, props))), node);
